import { axios } from '@/utils/request'

const API = {
  orgInfo: '/b/marketing/pc/store/getOrgInfo', // 获取机构信息
  getOrgIntro: 'b/material/pc/store/getOrgIntro', // 关于我们
  sendPhoneCode: 'b/student/studentApi/sendPhoneCode', // 获取验证码
  sendPhoneCodeNew: '/user/biz/student/pc/sendSmsCode', // 获取验证码
  // sendRegisterPhoneCode: 'b/student/studentApi/sendRegisterPhoneCode', // 注册获取验证码
  sendRegisterPhoneCode: '/user/biz/student/pc/sendRegisterSmsCode', // 注册获取验证码
  checkMobileSmsCode: 'b/student/studentApi/checkMobileSmsCode', // 验证验证码
  getWechatMiniQrcodeUrl: '/b/org/stu/web/common/getWechatMiniQrcodeUrl', // 获取二维码
  getGeoArea: 'b/marketing/common/getGeoArea', // 获取城市数据
  activation: '/b/classes/code/v2/activation', // 课程码激活
  existMobile: '/b/student/student/exist/mobile' // 检测账号是否以注册
  // /b/student/student/exist/mobile?orgCode=accdev&mobile=15606970387
}

// 通过机构码获取机构信息
export const feachOrgInfo = ocode => {
  return axios({
    url: API.orgInfo,
    method: 'get',
    headers: {
      ocode
    }
  })
}
// 关于我们
export const getOrgIntro = () => {
  return axios({
    url: API.getOrgIntro,
    method: 'GET'
  })
}
// 获取验证码
export const featchCode = params => {
  return axios({
    url: API.sendPhoneCode,
    method: 'GET',
    params
  })
}
// 获取验证码新
export const sendPhoneCodeNew = data => {
  return axios({
    url: API.sendPhoneCodeNew,
    method: 'POST',
    data
  })
}
// 注册获取验证码
export const sendRegisterPhoneCode = data => {
  return axios({
    url: API.sendRegisterPhoneCode,
    method: 'POST',
    data
  })
}
// 验证验证码
export const verifyCode = data => {
  return axios({
    url: API.checkMobileSmsCode,
    method: 'POST',
    data
  })
}

export const featchAppQrCode = () => {
  return axios({
    url: API.getWechatMiniQrcodeUrl,
    method: 'POST',
    data: {},
    headers: {
      ocode: 'ybjg',
      oid: '9e21b8650c474f3abd1fcf2b7b7e869f'
    }
  })
}

export const featchAreaData = id => {
  return axios({
    url: `${API.getGeoArea}?id=${id}`,
    method: 'GET'
  })
}
export const getMapJSON = () => {
  return axios({
    url: `/oss/map/app/get/map`,
    method: 'GET'
  })
}

// 课程码激活
export const activationCode = data => {
  return axios({
    url: API.activation,
    method: 'POST',
    data
  })
}

// 获取obs .o文件内容
export const feachObsO = url => {
  return axios({
    url,
    method: 'GET'
  })
}

export const existMobile = params => {
  return axios({
    url: API.existMobile,
    method: 'GET',
    params
  })
}
